import { Dispatch, createContext } from "react";
import { Analysis, State, Action } from "./types";
import { reducer } from "./reducer";
import {
  createStateHook,
  createDispatchHook,
  createContextHook,
  createProvider,
} from "../factory";
export { useActions } from "./useActions";

/**
 * The initial state of analysis context
 */
export const initialState: Analysis = {
  viewMode: "monitoring",
};

const stateContext = createContext<State | undefined>(undefined);
const dispatchContext = createContext<Dispatch<Action> | undefined>(undefined);

/**
 * Define a context around Analysis components.
 * The context is intended to be used on shared stuff between insights and monitoring views.
 * e.g. monitoring view can have different datagrid columns or toolbar compared to insights view.
 * This help us to render approrpriate underlying components.
 */
export const AnalysisProvider = createProvider(
  stateContext,
  dispatchContext,
  reducer,
  initialState
);
export const useState = createStateHook(stateContext);
export const useDispatch = createDispatchHook(dispatchContext);
export const useAnalysis = createContextHook(stateContext, dispatchContext);
